import { useEffect, useRef } from "react";
import Clients from "../../images/services/clients.png";
import fmiti from "../../images/products/fmiti_895x347.png";

const logos = [
  { src: Clients, alt: "clients" },
  { src: fmiti, alt: "fmiti" },
];

function ServicesClients() {
  const trackRef = useRef(null);

  // Duplicate dynamically for seamless loop
  const scrollingLogos = [...logos, ...logos];

  useEffect(() => {
    const track = trackRef.current;
    if (!track) return;

    const SPEED = 120;

    const applyDuration = () => {
      const distance = track.scrollWidth / 2;
      const duration = distance / SPEED;

      track.style.animation = "none";
      void track.offsetHeight; // force reflow (lint-safe)
      track.style.animation = `clients-scroll ${duration}s linear infinite`;
    };

    const images = track.querySelectorAll("img");
    let loaded = 0;

    images.forEach((img) => {
      if (img.complete) {
        loaded++;
      } else {
        img.onload = () => {
          loaded++;
          if (loaded === images.length) applyDuration();
        };
      }
    });

    if (loaded === images.length) applyDuration();
  }, []);

  //  Static marquee version
  // - CSS-only animation
  // - Fixed duration
  // - Scroll speed changes as logos are added

  // return (
  //   <div className="services-partners">
  //     <h1>Clients that trust our work</h1>
  //     {/* <div className="services-partners-images">
  //       {Array.from({ length: 8 }).map((_, i) => (
  //         <img key={i} src={Clients} alt="clients" />
  //         // <img key={i} src={fmiti} alt="fmiti" />
  //       ))}
  //     </div> */}

  //     <div className="products-partners-images">
  //       {scrollingLogos.map((logo, i) => (
  //         <img key={i} src={logo.src} alt={logo.alt} />
  //       ))}
  //     </div>

  //     <canvas className="shape1" />
  //     <canvas className="shape2" />
  //   </div>
  // );

  // Dynamic marquee version
  // - Uses DOM measurement (ref)
  // - Animation duration is calculated from pixel width
  // - Keeps scroll speed constant regardless of logo count

  return (
    // Commented out because Tailwind was uninstalled to prevent conflicts with existing CSS
    // <div className="relative w-full py-10">
    //   <h1 className="font-inter font-bold text-[36px] text-[#383885] text-center mb-10">
    //     Clients that trust our work
    //   </h1>

    <div
      style={{
        position: "relative",
        width: "100%",
        paddingTop: "40px",
        paddingBottom: "40px",
      }}
    >
      <h1
        style={{
          fontFamily: "Inter, sans-serif",
          fontWeight: "bold",
          fontSize: "36px",
          color: "#383885",
          textAlign: "center",
          marginBottom: "40px",
        }}
      >
        Clients that trust our work
      </h1>

      <div className="products-partners-images" ref={trackRef}>
        {scrollingLogos.map((logo, i) => (
          <img key={i} src={logo.src} alt={logo.alt} />
        ))}
      </div>

      <canvas className="shape1" />
      <canvas className="shape2" />
    </div>
  );
}

export default ServicesClients;
